import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgIf } from '@angular/common';
import { BrandingService } from '../services/user/branding.service';
import { AuthContextService } from '../services/auth-context.service';
import { TokenPropertyService } from '../services/token-property.service';
import { TilesService } from '../services/user/tiles.service';
import { CloudWatchRumService } from '../services/cloudwatch-rum.service';
import { SESSION_STORAGE_KEYS } from '../../constants';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [FontAwesomeModule, RouterLink, RouterLinkActive, NgIf],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderComponent implements OnInit {
  readonly internalHeaderLabel = 'Internal Reporting & Analytics';

  faGlobe = faGlobe;
  logoPath: string = null as any;

  readonly profileMenuItems = JSON.stringify([
    { uuid: 'settings', text: 'Settings', url: '/settings' }
  ]);

  constructor(
    private brandingService: BrandingService,
    private authContextService: AuthContextService,
    private tokenPropertyService: TokenPropertyService,
    private tilesService: TilesService,
    private cloudWatchRumService: CloudWatchRumService,
    private router: Router
  ) {}

  get logoRoute(): string {
    return this.authContextService.hasInternalAccess ? '/internal/reports-and-dashboards' : '/';
  }

  get isInternalUser(): boolean {
    return this.authContextService.hasInternalAccess;
  }

  get userEmail(): string {
    return this.tokenPropertyService.getPropertyFromToken('custom:emailId', 'id_token')
      || this.tokenPropertyService.getPropertyFromToken('email', 'id_token')
      || '';
  }

  ngOnInit(): void {
    this.brandingService.getLogoPath().subscribe({
      next: (logo: string) => this.logoPath = logo,
      error: () => this.logoPath = './assets/alight_worklife_logo_black.svg'
      });
  }

  onLogoutClicked(): void {
    this.tilesService.clearEmbedUrlCache();
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.CHAT_HISTORY);
    this.cloudWatchRumService.recordLogoutEvent(false, 'user_initiated');
    this.router.navigate(['/logoff'], { state: { logoutSource: 'user_initiated' } });
  }

  onProfileMenuItemClicked(event: Event): void {
    const url = (event as CustomEvent).detail?.url;
    if (url && url !== 'submenu') {
      this.router.navigate([url]);
    }
  }
}
